// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --vc-clr-primary: #000;
  --vc-clr-secondary: #090f207f;
  --vc-clr-white: #ffffff;
}

.carousel,
.carousel * {
  box-sizing: border-box;
}

.carousel {
  height: var(--vc-carousel-height);
  overscroll-behavior: none;
  position: relative;
  touch-action: pan-x pan-y pinch-zoom;
  z-index: 1;
}

.carousel.is-dragging {
  touch-action: none;
}

.carousel__track {
  display: flex;
  gap: var(--vc-slide-gap);
  height: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  transition: transform ease-out;
  transition-duration: var(--vc-transition-duration);
  width: 100%;
}

.carousel__viewport {
  height: 100%;
  overflow: hidden;
  width: 100%;
}

.carousel__sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.carousel.is-rtl {
  direction: rtl;
}

.carousel.is-ttb .carousel__track {
  flex-direction: column;
}

.carousel.is-btt .carousel__track {
  flex-direction: column-reverse;
}

.carousel.is-vertical .carousel__slide--clone:first-child {
  margin-block-start: var(--vc-cloned-offset);
}

.carousel:not(.is-vertical) .carousel__slide--clone:first-child {
  margin-inline-start: var(--vc-cloned-offset);
}

.carousel.is-effect-fade .carousel__track {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 100%;
  transition: none;
}

.carousel.is-effect-fade .carousel__slide {
  grid-area: 1 / 1;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity ease-in-out;
  transition-duration: var(--vc-transition-duration);
  width: 100%;
}

.carousel.is-effect-fade .carousel__slide--active {
  opacity: 1;
  pointer-events: auto;
}

:root {
  --vc-icn-width: 100%;
}

.carousel__icon {
  fill: currentColor;
  height: var(--vc-icn-width);
  width: var(--vc-icn-width);
}

:root {
  --vc-nav-background: transparent;
  --vc-nav-border-radius: 0;
  --vc-nav-color: var(--vc-clr-primary);
  --vc-nav-color-hover: var(--vc-clr-secondary);
  --vc-nav-height: 30px;
  --vc-nav-width: 30px;
}

.carousel__next,
.carousel__prev {
  align-items: center;
  background: var(--vc-nav-background);
  border: 0;
  border-radius: var(--vc-nav-border-radius);
  color: var(--vc-nav-color);
  cursor: pointer;
  display: flex;
  font-size: var(--vc-nav-height);
  height: var(--vc-nav-height);
  justify-content: center;
  padding: 0;
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  width: var(--vc-nav-width);
}

.carousel__next--disabled,
.carousel__prev--disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.carousel__next {
  inset-inline-end: 0;
}

.carousel__prev {
  inset-inline-start: 0;
}

.carousel.is-vertical {
  .carousel__next,
  .carousel__prev {
    inset-inline: auto 50%;
    inset-block-start: auto;
    transform: translateX(50%);
  }

  &.is-ttb {
    .carousel__next {
      inset-block-end: 0;
    }
    .carousel__prev {
      inset-block-start: 0;
    }
  }

  &.is-btt {
    .carousel__next {
      inset-block-start: 0;
    }
    .carousel__prev {
      inset-block-end: 0;
    }
  }
}

@media (hover: hover) {
  .carousel__next:hover,
  .carousel__prev:hover {
    color: var(--vc-nav-color-hover);
  }
}

:root {
  --vc-pgn-active-color: var(--vc-clr-primary);
  --vc-pgn-background-color: var(--vc-clr-secondary);
  --vc-pgn-border-radius: 0;
  --vc-pgn-gap: 6px;
  --vc-pgn-height: 4px;
  --vc-png-bottom: 10px;
  --vc-png-left: auto;
  --vc-png-right: 10px;
  --vc-pgn-width: 16px;
}

.carousel__pagination {
  bottom: var(--vc-png-bottom);
  display: flex;
  gap: var(--vc-pgn-gap);
  justify-content: center;
  left: 50%;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  transform: translateX(-50%);
}

.carousel__pagination-button {
  background-color: var(--vc-pgn-background-color);
  border: 0;
  border-radius: var(--vc-pgn-border-radius);
  cursor: pointer;
  display: block;
  height: var(--vc-pgn-height);
  margin: 0;
  padding: 0;
  width: var(--vc-pgn-width);
}

.carousel__pagination-button--active {
  background-color: var(--vc-pgn-active-color);
}

@media (hover: hover) {
  .carousel__pagination-button:hover {
    background-color: var(--vc-pgn-active-color);
  }
}

.carousel.is-vertical {
  .carousel__pagination {
    bottom: 50%;
    flex-direction: column;
    left: var(--vc-png-left);
    right: var(--vc-png-right);
    transform: translateY(50%);
  }

  .carousel__pagination-button {
    height: var(--vc-pgn-width);
    width: var(--vc-pgn-height);
  }
}

.carousel.is-btt .carousel__pagination {
  flex-direction: column-reverse;
}

.carousel__slide {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin: 0;
  transform: translateZ(0);
}

`, "",{"version":3,"sources":["webpack://./node_modules/vue3-carousel/dist/carousel.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,+BAA+B;EAC/B,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,6CAA6C;EAC7C,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;EACT,0CAA0C;EAC1C,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE;MACE,kBAAkB;IACpB;IACA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;IACA;MACE,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;EAClD,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,SAAS;EACT,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,wBAAwB;AAC1B","sourcesContent":[":root {\n  --vc-clr-primary: #000;\n  --vc-clr-secondary: #090f207f;\n  --vc-clr-white: #ffffff;\n}\n\n.carousel,\n.carousel * {\n  box-sizing: border-box;\n}\n\n.carousel {\n  height: var(--vc-carousel-height);\n  overscroll-behavior: none;\n  position: relative;\n  touch-action: pan-x pan-y pinch-zoom;\n  z-index: 1;\n}\n\n.carousel.is-dragging {\n  touch-action: none;\n}\n\n.carousel__track {\n  display: flex;\n  gap: var(--vc-slide-gap);\n  height: 100%;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  transition: transform ease-out;\n  transition-duration: var(--vc-transition-duration);\n  width: 100%;\n}\n\n.carousel__viewport {\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n}\n\n.carousel__sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.carousel.is-rtl {\n  direction: rtl;\n}\n\n.carousel.is-ttb .carousel__track {\n  flex-direction: column;\n}\n\n.carousel.is-btt .carousel__track {\n  flex-direction: column-reverse;\n}\n\n.carousel.is-vertical .carousel__slide--clone:first-child {\n  margin-block-start: var(--vc-cloned-offset);\n}\n\n.carousel:not(.is-vertical) .carousel__slide--clone:first-child {\n  margin-inline-start: var(--vc-cloned-offset);\n}\n\n.carousel.is-effect-fade .carousel__track {\n  display: grid;\n  grid-template-columns: 100%;\n  grid-template-rows: 100%;\n  transition: none;\n}\n\n.carousel.is-effect-fade .carousel__slide {\n  grid-area: 1 / 1;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity ease-in-out;\n  transition-duration: var(--vc-transition-duration);\n  width: 100%;\n}\n\n.carousel.is-effect-fade .carousel__slide--active {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n:root {\n  --vc-icn-width: 100%;\n}\n\n.carousel__icon {\n  fill: currentColor;\n  height: var(--vc-icn-width);\n  width: var(--vc-icn-width);\n}\n\n:root {\n  --vc-nav-background: transparent;\n  --vc-nav-border-radius: 0;\n  --vc-nav-color: var(--vc-clr-primary);\n  --vc-nav-color-hover: var(--vc-clr-secondary);\n  --vc-nav-height: 30px;\n  --vc-nav-width: 30px;\n}\n\n.carousel__next,\n.carousel__prev {\n  align-items: center;\n  background: var(--vc-nav-background);\n  border: 0;\n  border-radius: var(--vc-nav-border-radius);\n  color: var(--vc-nav-color);\n  cursor: pointer;\n  display: flex;\n  font-size: var(--vc-nav-height);\n  height: var(--vc-nav-height);\n  justify-content: center;\n  padding: 0;\n  position: absolute;\n  inset-block-start: 50%;\n  transform: translateY(-50%);\n  width: var(--vc-nav-width);\n}\n\n.carousel__next--disabled,\n.carousel__prev--disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.carousel__next {\n  inset-inline-end: 0;\n}\n\n.carousel__prev {\n  inset-inline-start: 0;\n}\n\n.carousel.is-vertical {\n  .carousel__next,\n  .carousel__prev {\n    inset-inline: auto 50%;\n    inset-block-start: auto;\n    transform: translateX(50%);\n  }\n\n  &.is-ttb {\n    .carousel__next {\n      inset-block-end: 0;\n    }\n    .carousel__prev {\n      inset-block-start: 0;\n    }\n  }\n\n  &.is-btt {\n    .carousel__next {\n      inset-block-start: 0;\n    }\n    .carousel__prev {\n      inset-block-end: 0;\n    }\n  }\n}\n\n@media (hover: hover) {\n  .carousel__next:hover,\n  .carousel__prev:hover {\n    color: var(--vc-nav-color-hover);\n  }\n}\n\n:root {\n  --vc-pgn-active-color: var(--vc-clr-primary);\n  --vc-pgn-background-color: var(--vc-clr-secondary);\n  --vc-pgn-border-radius: 0;\n  --vc-pgn-gap: 6px;\n  --vc-pgn-height: 4px;\n  --vc-png-bottom: 10px;\n  --vc-png-left: auto;\n  --vc-png-right: 10px;\n  --vc-pgn-width: 16px;\n}\n\n.carousel__pagination {\n  bottom: var(--vc-png-bottom);\n  display: flex;\n  gap: var(--vc-pgn-gap);\n  justify-content: center;\n  left: 50%;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  transform: translateX(-50%);\n}\n\n.carousel__pagination-button {\n  background-color: var(--vc-pgn-background-color);\n  border: 0;\n  border-radius: var(--vc-pgn-border-radius);\n  cursor: pointer;\n  display: block;\n  height: var(--vc-pgn-height);\n  margin: 0;\n  padding: 0;\n  width: var(--vc-pgn-width);\n}\n\n.carousel__pagination-button--active {\n  background-color: var(--vc-pgn-active-color);\n}\n\n@media (hover: hover) {\n  .carousel__pagination-button:hover {\n    background-color: var(--vc-pgn-active-color);\n  }\n}\n\n.carousel.is-vertical {\n  .carousel__pagination {\n    bottom: 50%;\n    flex-direction: column;\n    left: var(--vc-png-left);\n    right: var(--vc-png-right);\n    transform: translateY(50%);\n  }\n\n  .carousel__pagination-button {\n    height: var(--vc-pgn-width);\n    width: var(--vc-pgn-height);\n  }\n}\n\n.carousel.is-btt .carousel__pagination {\n  flex-direction: column-reverse;\n}\n\n.carousel__slide {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin: 0;\n  transform: translateZ(0);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
